import React, { FunctionComponent } from "react";

import { useUserData } from "../../hooks/useUserData";
import { useAuthentication } from "../../hooks/useAuthentication";
import { FormBuilder } from "./FormBuilder";
import { ContentLayout } from "../common/Layout";
import { useUserIdParam } from "../../hooks/useUserIdParam";

interface Props {
  isAuthenticated: boolean;
}

export const Form: FunctionComponent<Props> = ({ isAuthenticated }) => {
  const userId = useUserIdParam();
  const [userData, isLoading, isError] = useUserData(userId);
  useAuthentication(isAuthenticated);

  if (isError) return <p>Fehler beim Laden der Daten</p>;
  return (
    <ContentLayout title={"Formular"} siteTitle={"Spielgruppe Online - Formular"} isLoading={isLoading}>
      <FormBuilder userId={userId} formSettings={userData?.settings?.formSettings} />
    </ContentLayout>
  );
};
